import { useCallback, memo } from 'react';

import { Button } from 'UIPackage/MainModule/components/Button';
import { IUserOrganization } from 'APIPackage/AuthModule/interfaces/IUserOrganization';

import styles from './OrganizationRow.module.scss';

interface IOrganizationRowProps {
  data: IUserOrganization;
  onEnter: (organization: IUserOrganization) => void;
}

export const OrganizationRow = memo(({ data, onEnter }: IOrganizationRowProps) => {
  const onClick = useCallback(() => onEnter(data), [data, onEnter]);

  return (
    <tr>
      <td className={styles.FullNameCell}>{data.fullName}</td>
      <td className={styles.OgrnCell}>{data.OGRN}</td>
      <td>
        <Button color="primary" text="Войти" onClick={onClick} />
      </td>
    </tr>
  );
});
